import React from 'react';
import WorkspaceGuideDialog from '../../../shared/ui/common/WorkspaceGuideDialog';
import { buildValidationConfigurationGuideContent } from './validationConfigurationGuideContent';

interface ValidationConfigurationGuideDialogProps {
  open: boolean;
  onClose: () => void;
  onStartTour: () => void;
  selectedValidationCount: number;
  totalValidationCount: number;
}

const ValidationConfigurationGuideDialog: React.FC<ValidationConfigurationGuideDialogProps> = ({
  open,
  onClose,
  onStartTour,
  selectedValidationCount,
  totalValidationCount,
}) => (
  <WorkspaceGuideDialog
    open={open}
    onClose={onClose}
    dialogTitle="Validation configuration guide window"
    onAction={onStartTour}
    {...buildValidationConfigurationGuideContent({
      enabledCount: selectedValidationCount,
      totalCount: totalValidationCount,
    })}
  />
);

export default ValidationConfigurationGuideDialog;
